export default "__VITE_ASSET__CugPgcnK__"